var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.request.method && _vm.request.endpoint)?_c('div',[_c('div',{staticClass:"textRequest"},[_vm._v("Endpoint")]),_vm._v(" "),_c('div',{staticClass:"request"},[_c('div',{class:_vm.request.method},[_vm._v(_vm._s(_vm.request.method))]),_vm._v(" "),_c('div',{staticClass:"endpoint"},[_vm._v(_vm._s(_vm.request.endpoint))])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02b8dc00","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/documentation/RequestView.vue
// module id = null
// module chunks = 